import React from "react";
import "./Spinner.css";

const Spinner = ({ size = 36, color = "#18191aff" }) => (
  <div
    className="spinner"
    style={{
      width: size,
      height: size,
      borderWidth: size / 15,
      borderTopColor: color,
    }}
  />
);

export default Spinner;